import { BulkAction } from 'components/common';
import { AMPLITUDE_REGISTRATION_ACTIONS } from 'hooks/amplitude';
import { EmailType } from '../SendEmailModal';
import { ModalType, ParticipantListModal } from './types';

interface BulkActionsProps {
  disabled: boolean;
  handleAmplitudeAction: (
    registration_action: AMPLITUDE_REGISTRATION_ACTIONS
  ) => void;
  setModal: (modal: ParticipantListModal) => void;
  setEmailType: (emailType: EmailType) => void;
  handleExportSelected: () => void;
  clearFormResult: () => void;
  handleEmailAll: () => void;
}

export const getBulkActions = ({
  disabled,
  clearFormResult,
  handleAmplitudeAction,
  setModal,
  handleExportSelected,
  handleEmailAll,
  setEmailType,
}: BulkActionsProps): BulkAction[] => {
  const bulkActions = [
    {
      label: 'Export Selected',
      disabled,
      onSelected: () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_EXPORT);
        handleExportSelected();
        setModal({ isOpen: true, modalType: ModalType.EXPORT });
      },
    },
    {
      label: 'Ready to Roster',
      disabled,
      onSelected: () => {
        handleAmplitudeAction(
          AMPLITUDE_REGISTRATION_ACTIONS.BULK_READY_TO_ROSTER
        );
        setModal({ isOpen: true, modalType: ModalType.ROSTER });
      },
    },
    {
      label: 'Email Selected',
      disabled,
      onSelected: () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_EMAIL);
        setEmailType('');
        setModal({ isOpen: true, modalType: ModalType.EMAIL });
      },
    },
    {
      label: 'Email All',
      onSelected: async () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_EMAIL_ALL);
        setEmailType('all');
        handleEmailAll();
        setModal({ isOpen: true, modalType: ModalType.EMAIL });
      },
    },
    {
      label: 'Delete Selected',
      disabled,
      onSelected: () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_DELETE);
        setModal({ isOpen: true, modalType: ModalType.DELETE_FORM_RESULT });
      },
    },
    {
      label: 'Accept from Waitlist',
      disabled,
      onSelected: async () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_ACCEPT);
        clearFormResult();
        setModal({ isOpen: true, modalType: ModalType.OFFER });
      },
    },
    {
      label: 'Release from Waitlist',
      disabled,
      onSelected: async () => {
        handleAmplitudeAction(AMPLITUDE_REGISTRATION_ACTIONS.BULK_RELEASE);
        clearFormResult();
        setModal({ isOpen: true, modalType: ModalType.REMOVE_WAITLIST });
      },
    },
  ];
  return bulkActions;
};
